import { getStore } from '../store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isConversationReadingPaneViewStateLoaded(conversationId: string): boolean {
    if (isFeatureEnabled('rp-persistedReadingPaneTabs') && conversationId) {
        return getStore().loadedConversationReadingPaneViewStates.has(conversationId);
    }
    return false;
}
